var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "upload-icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_222",
    "data-name": "Ret\\xE2ngulo 222",
    width: 25,
    height: 25,
    fill: "#a5adc6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_62",
    "data-name": "Grupo 62",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M12.38,28.7c-2.28,0-4.559.019-6.838-.005A5.351,5.351,0,0,1,.728,25.948a5.157,5.157,0,0,1-.711-2.61c-.024-1.562-.019-3.124,0-4.686A1.132,1.132,0,0,1,1.5,17.48a1.113,1.113,0,0,1,.777,1.128c0,1.505,0,3.011,0,4.516a3.147,3.147,0,0,0,3.318,3.3q6.818,0,13.634,0a3.146,3.146,0,0,0,3.307-3.314q0-2.258,0-4.516a1.1,1.1,0,0,1,.635-1.058,1.079,1.079,0,0,1,1.154.1,1.125,1.125,0,0,1,.476.985c-.013,1.786.012,3.574-.078,5.356A5.274,5.274,0,0,1,20.1,28.617c-1.29.076-2.586.065-3.879.077s-2.561,0-3.841,0",
    transform: "translate(0 -3.903)",
    fill: "#a5adc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M12.449,3.877a3.957,3.957,0,0,1-.348.47Q9.975,6.487,7.837,8.613a1.13,1.13,0,0,1-1.872-.24,1.192,1.192,0,0,1,.33-1.411q1.891-1.9,3.785-3.789Q11.437,1.817,12.794.461A1.156,1.156,0,0,1,14.631.449Q17.9,3.71,21.161,6.979a1.167,1.167,0,0,1,.1,1.69,1.136,1.136,0,0,1-1.712-.1Q17.386,6.407,15.228,4.24a2.848,2.848,0,0,1-.251-.336l-.14.057v.422q0,6.687-.009,13.375a2.043,2.043,0,0,1-.189.884,1.046,1.046,0,0,1-1.162.483,1.087,1.087,0,0,1-.861-.969c-.016-.168-.013-.338-.013-.506q0-6.6,0-13.206V3.987l-.152-.109",
    transform: "translate(-1.312 0)",
    fill: "#a5adc6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.ac16a36640136a9c9341560f403e60b0.svg";
export { ForwardRef as ReactComponent };